type GetBackNavigationLabelParams = {
  isInIframe: boolean
  currentIndex: number
  backUrl: string | undefined
  isFirstPage: boolean
}

type GetBackNavigationLabelResult = {
  backLabel: string | undefined
  isBackButtonHidden: boolean
}

export const getBackNavigationLabel = ({
  isInIframe,
  currentIndex,
  backUrl,
  isFirstPage
}: GetBackNavigationLabelParams): GetBackNavigationLabelResult => {
  const backLabel =
    !isInIframe || currentIndex > 0 || backUrl ? 'Zurück' : undefined
  const isBackButtonHidden = !backLabel || isFirstPage

  return { backLabel, isBackButtonHidden }
}
